import React, { PureComponent } from 'react'
import autobind from 'autobind-decorator'
import { browserHistory } from 'react-router'
import styles from './styles'

import Controller from '../FormsController'

import Alert from '../Alert'
import Button from '../Button'
import BackButton from '../BackButton'

export default class Form extends PureComponent {
  state = { valid: false, emailVaild: false, intial: true }

  onChange(event) {
    let field = event.target.name.toLowerCase()
    let value = event.target.value
    Controller.update(field, value)
  }

  componentDidMount() {
    this.refs.fullname.value = Controller.fullname
    this.refs.email.value = Controller.email
  }

  get valid() {
    if (!this.state.valid && !this.state.intial) {
      return (<Alert message='Please fill in all fields' />)
    }
  }

  get validEmail() {
    if (!this.state.emailVaild && !this.state.intial) {
      return (<Alert message='Please enter a valid email' />)
    }
  }

  isEmailValid(email) {
    let value = this.refs.email.value
    let isValid = value.match(/.+@.+\..+/)
    return isValid
  }

  @autobind next() {
    const { fullname, email, company } = this.refs
    if (!(fullname.value && email.value)) {
      this.setState({ valid: false, intial: false, emailVaild: true })
    } else if (!this.isEmailValid(email.value)) {
      this.setState({ valid: true, intial: false, emailVaild: false })
    } else {
      this.props.change(this.props.nextQuestion)
    }
  }

  @autobind goBack() {
    browserHistory.push('/')
  }

  @autobind goToNext(event) {
    if (event.key === 'Enter') {
      if (event.target.name === 'Fullname') this.refs.email.focus()
      else if (event.target.name === 'Email') this.next()
    }
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <form method='post' action='#' ref='form' >
          <input className={styles.input} onChange={this.onChange} onKeyDown={this.goToNext} ref='fullname' type='text' name='Fullname' placeholder='FULL NAME' />
          <input className={styles.input} onChange={this.onChange} onKeyDown={this.goToNext} ref='email' type='email' name='Email' placeholder='EMAIL' />
        </form>
        { this.valid }
        { this.validEmail }
        <div className={styles.buttonDiv}>
          <div className={styles.buttonBack}>
            <BackButton onClick={this.goBack} />
          </div>
          <div className={styles.buttonNext}>
            <Button onClick={this.next}>
              NEXT
              <svg width='25' height='25' viewBox='0 0 24 24'>
                <path d='M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z' />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/Form/Form.js
 **/